import React, { memo } from 'react';
import { Switch, Route } from 'react-router-dom';
import WarehouseReleasesDetails from 'views/WarehouseReleasesList/WarehouseReleasesDetails';
import WarehouseReleasesList from 'views/WarehouseReleasesList/WarehouseReleasesList';
const WarehouseReleases = ({ url }) => (React.createElement(Switch, null,
    React.createElement(Route, { exact: true, path: `${url}` },
        React.createElement(WarehouseReleasesList, null)),
    React.createElement(Route, { path: `${url}/:warehouseReleaseId` },
        React.createElement(WarehouseReleasesDetails, null))));
export default memo(WarehouseReleases);
